import { createContext } from 'react';

export interface QuantityDraftContextValue {
  drafts: ReadonlyMap<string, string>;
  setDraft: (suggestionId: string, value: string | null) => void;
  /** Lines with a quantity save in flight. */
  pending: ReadonlySet<string>;
  /**
   * Marks the line's save pending until `save` settles, and returns it. Lives
   * above the table so a row that scrolls out of a virtualized table and back
   * still knows its save is in flight.
   */
  trackSave: <T>(
    suggestionIds: string | readonly string[],
    save: Promise<T>,
  ) => Promise<T>;
}

export const QuantityDraftContext =
  createContext<QuantityDraftContextValue | null>(null);
